import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="bg-navy pb-20 px-6" data-id="element-242">
      <div className="max-w-3xl mx-auto" data-id="element-243">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-244">
          <h3 className="text-amber-500 font-bold tracking-wider text-sm uppercase mb-6" data-id="element-245">
            El Verdadero Problema
          </h3>

          <div className="space-y-6 text-lg text-slate-200 leading-relaxed" data-id="element-246">
            <p data-id="element-247">
              👉 <strong data-id="element-248">El problema no es el mensaje de tu ex.</strong>
            </p>
            <p data-id="element-249">
              El problema es que le diste la{' '}
              <strong className="text-white font-bold bg-amber-900/40 px-1" data-id="element-250">
                "llave maestra" de tu tranquilidad
              </strong>{' '}
              las 24 horas del día.
            </p>
            <p data-id="element-251">
              Cada vez que respondés <em data-id="element-252">desde la herida</em>, cada vez que
              intentás "explicar" tu punto de vista o justificar lo que
              hiciste... <strong data-id="element-253">estás mordiendo el anzuelo</strong>.
            </p>

            <p className="pt-4 border-t border-slate-800" data-id="element-254">
              Esa energía que gastás tipeando testamentos de odio es{' '}
              <strong className="text-white font-bold border-b-2 border-red-500/50" data-id="element-255">
                energía que le robás a tus hijos
              </strong>
              .
            </p>
            <p data-id="element-256">
              Ellos te necesitan presente, no con los ojos inyectados en sangre
              mirando una pantalla mientras ellos juegan solos.
            </p>

            <div className="my-10 flex justify-center" data-id="element-257">
              <img src="https://cdn.magicpatterns.com/uploads/mcxGcQATxirksxMtkApPg2/Diseno_sin_titulo_(1).png" alt="Padres estresados mirando sus celulares por mensajes conflictivos" className="w-full md:w-full rounded-2xl shadow-2xl shadow-black/40 border border-slate-700/50" data-id="element-258" />
            </div>

            <div className="bg-slate-800/50 p-6 rounded-xl border border-slate-700 mt-8 shadow-lg" data-id="element-259">
              <p className="text-xl font-playfair font-bold text-white text-center" data-id="element-260">
                🔥 El conflicto se alimenta de tu reacción. <br data-id="element-261" />
                <span className="text-amber-400" data-id="element-262">
                  Si no hay reacción, el fuego se apaga.
                </span>
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}